// extracted by mini-css-extract-plugin
export default {"Wrapper":"PanelMenu_Wrapper__IDF46","Item":"PanelMenu_Item__FGSQ3","ItemActive":"PanelMenu_ItemActive__buZ-c"};